/*
 * @Copyright: Copyright (c) Pray LLC. All rights reserved.
 * @Author: Raguvind Tharanitharan
 * @Date: 2022-09-12 10:18:12
 * @Last Modified by: Raguvind Tharanitharan
 * @Last Modified time: 2022-09-12 22:12:00
*/
import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import GlobalStyles from "@mui/material/GlobalStyles";
import LoginView from './components/vw-login';
import withRouter from '../with-router';
import './styles/local-style.css';

export default withRouter(function HomeDefaultView(props) {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    // Validating if the user is already populated or not.
    // If the user is loaded then navigated to dashboard.
    if (user != null) {
      navigate('/dashboard');
    }
  });

  // Render components of the login screen.
  return <>
    <GlobalStyles
      styles={{
        body: { backgroundColor: "#0B0C0D", color: "#FFF" }
      }}
    />
    <Routes>
      <Route exact path="/" element={<LoginView />} />
    </Routes>
  </>;
});